<template>
  <div class="hornor-buy-goods-details">
    <div class="goods-details-wrapper">
      <goback title="商品详情"></goback>
      <template v-if="currentSku">
        <div class="proudct-imgs">
          <img v-lazy="currentSku.pic_url" alt />
          <!-- <button
            class="platform-tips"
            v-if="currentSku.platform_info"
            @click="jumpLink(currentSku.platform_info)"
          >
            <span class="tips">{{ currentSku.platform_info.brand }}</span>
          </button> -->
        </div>
        <div class="proudct-intro van-hairline--top-bottom">
          <div class="price">
            <div class="double-price">
              <div class="buy-price" v-if="currentSku.equity">购买价: <em><span>¥</span>{{currentSku.equity.discount}}</em></div>
              <del class="normal-price">原价: {{currentSku.market_price}}</del>
            </div>
            <div class="sku-tips" v-if="currentSku.equity">
              {{currentSku.equity.discount | diffPrice(currentSku.market_price)}}
            </div>
          </div>
          <div class="title">{{ currentSku.name }}</div>
        </div>
        <div class="product-standard" v-if="currentSku.attr_list">
          <a href="javascript:;" class="product-standard-desc">
            <div class="standard" v-show="currentSku.attr_list.length">
              <span>规格</span>
              <span v-for="(guige, index) in currentSku.attr_list" :key="index">
                {{ guige.attr_value.value }}
              </span>
            </div>
            <div class="more"></div>
          </a>
        </div>
        <div class="product-desc-imgs">
          <div class="desc-title">
            <h3>商品详情</h3>
          </div>
          <div class="desc-imgs" id="desc" v-if="currentSku">
            <div class="desc-img-intro" v-html="htmlDetails"></div>
          </div>
        </div>
      </template>
      <div class="goods-actions van-hairline--top">
        <div class="total">
          购买价: <em v-if="currentSku.equity"><span>¥</span> {{currentSku.equity.discount}}</em>
        </div>
        <button class="buy" @click="buyNowHandler">购买</button>
      </div>
    </div>

    <dialogs
      v-model="dialog.show"
      show-msg
      @cancel-handler="dialogCancel"
      @confrim-handler="dialogConfrim"
    >
      <template #msg>
        <div>你确定要跳到 {{ dialog.platformName }} 查看原价吗?</div>
      </template>
    </dialogs>
    <!-- <dialogs
      v-model="getFree.show"
      show-msg
      @cancel-handler="cancelGetFree"
      @confrim-handler="sureGetFree"
      >
      <template #msg>
        <div class="get-free-desc">
          <p>您确定要领取该商品么?</p>
          <p>(本商品仅限领取一次)</p>
        </div>
      </template>
    </dialogs> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Dialogs from '../../components/Dialog'
import Goback from '../../components/Goback'
import Big from 'big.js'
// import { wechat } from '../../utils/wechat'
let flag = false
let timer = null
const init = new Big(0)
export default {
  name: 'hornorBuyGoodsDetails',
  components: {
    Goback,
    Dialogs
  },
  data () {
    return {
      current: 1,
      show: false,
      currentSku: {},
      dialog: {
        show: false,
        platformName: ''
      },
      getFree: {
        show: false
      },
      jumpPlatformName: '',
      jumpPlatforms: ['yanxuan', 'jd', 'suning'],
      htmlHeight: 0,
      htmlDetails: ''
    }
  },
  filters: {
    diffPrice (discountPrice, normalPrice) {
      if (discountPrice * 1) {
        return `直降${init.plus(normalPrice).minus(discountPrice).toFixed(2)}`
      } else {
        return '0元购'
      }
    }
  },
  computed: {
    ...mapState('store', ['Authorization']),
    skuInfo () {
      return this.$route.query
    }
  },
  created () {
    this.$toast.loading('加载中...')
    this.getSkuDetails().then(() => {
      // wechat({
      //   fullPath: this.$route.fullPath,
      //   name: this.$route.name,
      //   title: this.currentSku.name,
      //   desc: `黑卡PLUS会员专享价: ¥${skuPrice}`,
      //   imgUrl: currentSku.pic_url
      // })
      this.initDesc()
    })
  },

  methods: {
    ...mapActions('hornorBuy', [
      'getOrder'
    ]),
    async buyNowHandler () {
      if (flag) {
        return false
      }
      flag = true
      const status = await this.getUserRight()
      if (status) {
        await this.getOrder(this.currentSku)
        this.$router.push({ name: 'hornorBuyGoodsOrder', query: { aid: this.skuInfo.aid } })
      }
      flag = false
    },
    async getUserRight () {
      const res = await this.$axios.post('api/business/check', { gid: this.skuInfo.aid })
      if (res.status === 200) {
        const { code, msg } = res.data
        if (code === 0) {
          return true
        } else {
          this.$toast(msg)
          return false
        }
      }
    },
    dialogCancel () {
      this.dialog.show = false
    },

    /**
     * 跳转外部链接
     */
    dialogConfrim () {
      if (this.jumpPlatforms.includes(this.jumpPlatformName)) {
        location.href = `https://ab.buslive.cn/yunku/jump/detail?sku_id=${this.currentSku.sku_id}`
      }
    },

    /**
     * 查看价格二次确认
     */
    jumpLink ({ name, title }) {
      this.jumpPlatformName = name
      if (this.jumpPlatforms.includes(name)) {
        this.dialog.platformName = title
        this.dialog.show = true
      }
    },

    /**
     * 初始化h5大字段
     */
    async initDesc () {
      const status = await this.getHtmlDetails(this.skuInfo.skuid)
      const modules = document.getElementsByClassName('ssd-module')
      const widgetPics = document.getElementsByClassName('ssd-widget-pic')
      const moduleWrap = document.getElementsByClassName('ssd-module-wrap')
      if (status) {
        const links = document.getElementsByClassName('ssd-widget-link')
        if (links.length) {
          Array.from(links).forEach(v => {
            v.parentNode.parentNode.style.display = 'none'
          })
        }
        setTimeout(() => {
          this.setDetailHeight([widgetPics, modules, moduleWrap])
        }, 300)
      }

      // // 更新h5 大字段
      setTimeout(() => {
        this.htmlHeight = document.getElementById('desc')
          ? document.getElementById('desc').clientHeight
          : 0
        clearTimeout(timer)
        timer = setTimeout(() => {
          if (this.htmlHeight < 200) {
            this.updateHtml(this.skuInfo.skuid)
          }
        }, 800)
      }, 500)
    },
    /**
     * 获取h5大字段
     */
    async getHtmlDetails (skuid) {
      const res = await this.$axios({
        method: 'get',
        url: `${process.env.VUE_APP_HTML_URL}${skuid}/intro.html`
      })
      if (res.status === 200) {
        this.htmlDetails = res.data
        return true
      }
    },

    /**
     * 更新h5 大字段
     */
    async updateHtml () {
      await this.$axios.post('api/sys/h5-refresh', {
        sku_id: this.currentSku.sku_id
      })
    },

    /**
     * 获取商品详情
     */
    async getSkuDetails () {
      const { aid, goodsid, skuid, paltform } = this.$route.query
      this.goodsid = goodsid
      this.skuid = skuid
      this.paltform = paltform
      const res = await this.$axios.get(`api/business/detail/${aid}/${skuid}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.currentSku = data
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 设置h5大字段图片高度
     */
    setDetailHeight (els) {
      els.forEach(v => {
        for (let i = 0; i < v.length; i++) {
          if (
            (v[i].classList.length > 0 &&
              [...v[i].classList].includes('ssd-module-heading')) ||
            (v[i].classList.length === 1 &&
              [...v[i].classList].includes('ssd-module-wrap'))
          ) {
            continue
          } else {
            if (v[i].clientHeight) {
              v[i].style.height = v[i].clientHeight / 100 + 'rem'
            }
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.desc-imgs {
  width: 7.5rem;
  padding-bottom: 0.2rem;
  font-size: 0.28rem;
  word-break: break-all;
}
.desc-imgs >>> img {
  width: 100% !important;
  height: auto;
}
.desc-imgs .desc-img-intro >>> div {
  max-width: -webkit-fill-available !important;
  font-size: 0.34rem !important;
}
.desc-imgs .desc-img-intro >>> .ssd-widget-pic {
  max-width: unset !important;
  font-size: 0.2rem !important;
}
.desc-imgs .desc-img-intro >>> .ssd-module-mobile-wrap .ssd-widget-text,
.desc-imgs .desc-img-intro >>> .ssd-module-wrap .ssd-widget-text {
  font-size: 0.2rem !important;
  line-height: 1.1;
}

.desc-imgs >>> p {
  max-width: 7.5rem;
}
.desc-imgs >>> p img {
  width: 100%;
  vertical-align: top;
}
.desc-imgs >>> .ssd-module-wrap,
.desc-imgs .desc-img-intro >>> .ssd-module-mobile-wrap {
  width: 100% !important;
}

.desc-imgs .desc-img-intro >>> .ssd-module-heading-layout span {
  font-size: 0.2rem !important;
  line-height: none;
}

.desc-imgs >>> .ssd-good-name {
  font-size: 0.2rem !important;
}
.desc-img .desc-img-intro >>> .ssd-widget-text {
  font-size: 0.34rem !important;
  color: red;
}
.desc-imgs >>> table {
  width: 7.5rem !important;
  height: 100%;
  display: block;
}
.desc-imgs .desc-img-intro >>> table td,
.desc-imgs .desc-img-intro >>> table tbody,
.desc-imgs .desc-img-intro >>> table tr {
  display: block;
  width: 100%;
  height: 100%;
}

.desc-imgs >>> div[align="center"] div {
  width: 7.5rem !important;
}
.desc-imgs >>> #ssd-vc-goods,
.desc-imgs >>> .ssd-module-goods,
.desc-imgs >>> .ssd-module-heading {
  display: none;
}
</style>
<style lang="less" scoped>
.hornor-buy-goods-details {
  .safe-area-inset-bottom;
  .goods-details-wrapper {
    padding-top: 0.8rem;
    padding-bottom: 0.9rem;
    background-color: #fff;
  }
  .proudct-imgs {
    width: 100%;
    position: relative;
    .platform-tips {
      position: absolute;
      bottom: 0rem;
      left: 0.3rem;
      background-size: 100%;
      display: flex;
      .tips {
        position: relative;
        padding-left: 0.45rem;
        padding-right: 0.1rem;
        height: 0.35rem;
        font-size: @fz24;
        color: #ff2828;
        border: 0.5px solid #ff2828;
        background-color: #fff;
        &::before {
          position: absolute;
          left: 0;
          content: "";
          width: 0.35rem;
          height: 0.35rem;
          background: url("../../assets/img/z-icon.png") center no-repeat
            #ff2828;
          background-size: 0.3rem;
        }
      }
    }
    .swiper {
      height: 5.96rem;
      padding-bottom: 0.76rem;
      .custom-indicator {
        position: absolute;
        bottom: 0.35rem;
        left: 0.3rem;
        right: 0.3rem;
        .flex-between;
        .num {
          right: 0.3rem;
          width: 0.66rem;
          height: 0.34rem;
          .flex-center;
          border: 0.5px solid @c97;
          border-radius: 30px;
          color: @c97;
          font-size: @fz18;
        }
      }
    }
    .icon {
      width: 1.33rem;
      height: 0.35rem;
    }
  }
  .proudct-intro {
    padding: 0.2rem;
    .price {
      padding-bottom: 0.25rem;
      .flex-between;
      .double-price {
        .flex-center;
        font-size: @fz22;
        color: @base;
        .buy-price {
          color: @price;
          font-size: @fz22;
          em {
            font-size: @fz32;
            font-weight: 660;
             span {
              font-size: @fz22;
            }
          }
        }
        .normal-price {
          padding-left: 0.9rem;
          color: @base;
        }
      }
      .sku-tips {
        min-width: 0.6rem;
        padding: 0 0.15rem;
        height: 0.38;
        .flex-center;
        background-color: #FFEAEF;
        border-radius: 30px;
        color: @price;
        font-size: @fz22;
      }
    }
    .title {
      font-size: @fz28;
      color: @base;
      font-weight: 660;
      .ellipsis2;
    }
  }
  .product-platform-save {
    padding: 0 0.2rem;
    height: 0.5rem;
    display: flex;
    align-items: center;
    ul {
      display: flex;
      font-size: @fz18;
      li {
        padding-right: 0.26rem;
      }
    }
    img {
      width: 0.3rem;
    }
  }
  .product-standard {
    padding: 0 0.2rem;
    border-top: 0.2rem solid #f6f6f6;
    border-bottom: 0.2rem solid #f6f6f6;
    a.product-standard-desc {
      .flex-between;
      height: 0.78rem;
      font-size: @fz24;
      color: @base;
      .standard {
        span:nth-child(2) {
          font-size: fz22;
          padding-left: 0.48rem;
        }
      }
      .more {
        width: 0.48rem;
        height: 0.48rem;
        background: url("../../assets/img/more.png") center no-repeat;
        background-size: 100%;
      }
    }
  }
  .product-desc-imgs {
    .safe-area-inset-bottom;
    .desc-title {
      padding: 0.22rem 0.2rem;
      h3 {
        font-size: @fz26;
        color: @base;
        padding-left: 0.2rem;
        border-left: 0.1rem solid #ff3824;
      }
    }
  }
  .get-free-desc {
    p:nth-child(2) {
      padding-top: 0.15rem;
    }
  }
  .goods-actions {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding-left: 0.3rem;
    padding-right: 0.2rem;
    height: 0.88rem;
    background-color: #fff;
    .flex-between;
    font-size: @fz22;
    .safe-area-inset-bottom;
    .total {
      em {
        font-size: @fz32;
        font-weight: bold;
        color: @price;
        em {
          font-size: @fz22;
        }
      }
    }
    .buy {
      width: 1.8rem;
      height: 0.64rem;
      background-color: #fe3b3b;
      color: #fff;
      font-size: @fz26;
      border-radius: 30px;
    }
  }
}
</style>
